import type { ApiError, RedirectResponse, VerificationCode } from '@/types';
import { ErrorService } from '@/error/error.service';
import { errorCodeOf, getJson, postJson } from '@/utils/http';

export class VerificationService {
  public async get(codeId: string): Promise<VerificationCode | ApiError> {
    try {
      return await getJson<VerificationCode>(`/verification-code/${codeId}`);
    } catch (e) {
      return ErrorService.getError('ibis', errorCodeOf(e));
    }
  }

  public async validate(codeId: string, oneTimeCode: string): Promise<RedirectResponse | ApiError> {
    try {
      return await postJson<RedirectResponse>(`/verification-code/${codeId}/validate`, {
        code: oneTimeCode,
      });
    } catch (e) {
      return ErrorService.getError('ibis', errorCodeOf(e));
    }
  }

  public async resend(codeId: string): Promise<void | ApiError> {
    try {
      await postJson(`/verification-code/${codeId}/resend`);
    } catch (e) {
      return ErrorService.getError('ibis', errorCodeOf(e));
    }
  }
}
